import Navbar from './components/NavBar';
import Hero from './components/Hero';
import Highlights from './components/Highlights';
import Model from './components/Model';
import Features from './components/Features';
import HowItWorks from './components/HowItWorks';
import Footer from './components/Footer';

import * as Sentry from '@sentry/react'; 

// Explicitly named component
const AppComponent = () => {
  return (
    <main className="bg-black">
      <Navbar />
      <Hero />
      <Highlights />
      <Model />
      <Features />
      <HowItWorks />
      <Footer />
    </main>
  );
};

// Wrap AppComponent with Sentry Profiler
const AppWithProfiler = Sentry.withProfiler(AppComponent);
export default AppWithProfiler;
